import React, { useState, useEffect, useContext } from "react";
import { getCookie } from "../../helpers/cookies";
import Jobs from "../../pages/jobs/jobs";
import { DataContext } from "../../DataDetails";

export default function Main() {
  const { data, setData } = useContext(DataContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const user = getCookie("user");

  useEffect(() => {
    if (!data) {
      // fetch('http://18.134.7.61/connection/ajax/get/upcoming_jobs.php')
      // fetch('http://localhost/upcoming_jobs.php')
      // fetch('/connection/ajax/get/upcoming_jobs.php')
      // fetch('https://platform.makemyhousegreen.com/connection/react/get/upcoming_jobs.php', {
      // fetch('http://13.41.80.44/connection/react/get/professional_app_data.php', {
      fetch(
        "https://platform.makemyhousegreen.com/connection/react/get/professional_app_data.php",
        {
          method: "GET",
          headers: {
            user,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw response;
        })
        .then((data) => {
          setData(data);
        })
        .catch((error) => {
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  if (loading) return "Loading...";
  if (error) return "Error!";

  return <div>{data ? <Jobs /> : null}</div>;
}
